import {
  BlockUI,
  NgBlockUI
} from 'ng-block-ui';

import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnInit
} from '@angular/core';

import { TranslateService } from '@ngx-translate/core';
import { UIRouter }         from '@uirouter/core';

import { ChargifyService }          from './chargify.service';
import { CompanySubscriptionModel } from '../companies/models/company.subscription';
import { DateParserService }        from '../core/services/date-parser.service';
import { MessagesService }          from '../messages/messages.service';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector       : 'wor-chargify-trial-message',
  styles: [ require('./chargify.trial-message.component.scss') ],
  template: require('./chargify.trial-message.component.html')
})
export class ChargifyTrailMessageComponent implements OnInit {
  public daysLeft      = 0;
  private subscription : CompanySubscriptionModel;

  @BlockUI('chargifyTrialMessageBlock') block : NgBlockUI;

  constructor (
    private changeDetectorRef: ChangeDetectorRef,
    private chargifyService  : ChargifyService,
    private dateParserService: DateParserService,
    private messagesService  : MessagesService,
    private router           : UIRouter,
    private translateService : TranslateService
  ) {}

  ngOnInit (): void {
    this.block.start();

    this.chargifyService.getSubscription()
    .then(( subscription : CompanySubscriptionModel ) => {
      this.subscription = subscription;

      this.daysLeft = this.dateParserService.getDaysFromDate(this.subscription.trial_ended_at);

      this.changeDetectorRef.detectChanges();
    })
    .finally(() => {
      this.block.stop();
    });
  }

  activate () : void {
    this.chargifyService.activate(this.block)
    .then(() => {
      this.messagesService.show(this.translateService.instant('JS_SPACE.MESSAGES.USER_ACTIVATED'), 'success');

      this.router.stateService.reload();
    });
  };
}
